module.exports = __webpack_public_path__ + "img/4f_r_jindaiji@2x.0b793474.jpg";